"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteQueryGroup = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useDeleteQueryGroup(id) {
    const { data, isLoading, error, del } = (0, core_ui_1.useApiDelete)(`query-groups/${id}`);
    return {
        deletedQueryGroup: data,
        deletingGroup: isLoading,
        deleteError: error,
        deleteQueryGroup: del
    };
}
exports.useDeleteQueryGroup = useDeleteQueryGroup;
//# sourceMappingURL=useDeleteQueryGroup.js.map